import NavJson from "@/assets/nav.json";
import { INavMenu } from "@/models/interfaces/navigation.interface";

export const initListMenu = (): INavMenu[] => NavJson;
